import { Queue } from "@/tools/Queue";

export class NetLogicQueue extends Queue {
  static instance = null;

  static TIMEOUT = 1000 * 60 * 2;

  static getInstance() {
    if (!NetLogicQueue.instance) {
      NetLogicQueue.instance = new NetLogicQueue({
        concurrency: 1,
        timeout: NetLogicQueue.TIMEOUT,
        autostart: true,
        results: null,
      });
    }

    return NetLogicQueue.instance;
  }
}
